var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"533ca6d608f77a7f5cfee56ecc006850cfd0b228"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["dashbaord@orderbrot"]={id:"533ca6d608f77a7f5cfee56ecc006850cfd0b228"};
      